<template>
  <div class="orc-banner-wrap relative">

    <!-- Top banner -->
    <div class="bg-main my-top clearfix mb-4 relative orc-banner" v-bind:class="{ 'h-screen': branch.isPseudo }">

      <!-- Wave -->
      <div class="orc-wave"></div>

      <!-- Banner -->
      <div v-if="branch.isPseudo" class="absolute left-0 bottom-0 right-0 top-0 flex justify-center items-center">
        <div class="w-full orc-vert-limit-header">
          <el-row :gutter="10" class="mt-16">
            <el-col :xs="24" :sm="12" :md="12" :lg="12"  v-if="branch">
              <div class="mt-12 mb-8 pr-12">
                <h3 class="text-white text-xl font-thin text-left opacity-75">Welkom</h3>
                <h1 class="text-white text-4xl font-thin mb-4">{{ branch.title }}</h1>

                <content-displayer class="p-0 text-white  font-thin text-xl mt-4 mb-4" :current="branch.shortDescription"></content-displayer>
              </div>
                <div class="flex mt-4">
                <div class="mr-2">
                  <el-button class="self-center" type="secondary p-4" @click="showEnrollmentDialog(null)"> Inschrijven<i class="ml-4 el-icon-plus"></i></el-button>
                </div>
                <a class="social-badge mr-2" href="https://www.instagram.com/orcabilzen/">
                  <img src="../assets/instagram-brands.svg" width="20" height="20" class="text-white"/>
                </a>
                <a class="social-badge" href="https://www.facebook.com/OrcaBilzen/">
                  <img src="../assets/facebook-f-brands.svg" width="15" height="15"/>
                </a>
              </div>
            </el-col>
            <el-col :span="12" class="orc-img-disp">
              <photos :branch-id="branchId" class="h-full"></photos>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- Navigation -->
      <div class="w-full p-0 absolute inc-z">
        <orca-header :branch-id="branchId" :branch-options="branchOptions"></orca-header>
      </div>

      <div class="blob-container" v-if="branch.isPseudo">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="1000 500 2000 2000">
          <defs>
            <linearGradient
              id="c"
              x1="0.929"
              y1="0.111"
              x2="0.263"
              y2="0.935"
              gradientUnits="objectBoundingBox">
              <stop offset="0" stop-color="#f1f6f9" />
              <stop offset="1" stop-color="#f1f6f9" stop-opacity="0" />
            </linearGradient>
          </defs>
          <g data-name="blob-shape (3)" transform="scale(2.5)">
            <path
              class="blob"
              fill="url(#c)"
              d="M455.4 151.1c43.1 36.7 73.4 92.8 60.8 136.3-12.7 43.5-68.1 74.4-111.3 119.4-43.1 45-74 104.1-109.8 109-35.9 5-76.7-44.2-111.8-89.2-35.2-45-64.7-85.8-70.8-132.6-6-46.8 11.6-99.6 46.7-136.3 35.2-36.6 88-57.2 142.4-58.8 54.5-1.7 110.6 15.6 153.8 52.2z" />
          </g>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="blob"
          viewBox="-400 -200 2000 2000">
          <defs>
            <linearGradient
              id="c"
              x1="0.929"
              y1="0.111"
              x2="0.263"
              y2="0.935"
              gradientUnits="objectBoundingBox">
              <stop offset="0" stop-color="#f1f6f9" />
              <stop offset="1" stop-color="#f1f6f9" stop-opacity="0" />
            </linearGradient>
          </defs>
          <g data-name="blob-shape (3)" transform="scale(2)">
            <path
              class="blob"
              fill="url(#c)"
              d="M455.4 151.1c43.1 36.7 73.4 92.8 60.8 136.3-12.7 43.5-68.1 74.4-111.3 119.4-43.1 45-74 104.1-109.8 109-35.9 5-76.7-44.2-111.8-89.2-35.2-45-64.7-85.8-70.8-132.6-6-46.8 11.6-99.6 46.7-136.3 35.2-36.6 88-57.2 142.4-58.8 54.5-1.7 110.6 15.6 153.8 52.2z" />
          </g>
        </svg>
      </div>
    </div>

    <div class="orc-cont-wrap">
      <!-- Branches -->
      <branches v-if="branch.isPseudo" :branch-options="branchOptions"></branches>
      <branch v-else :branch="branch"></branch>

      <!-- News -->
      <news :branch-id="branchId" id="news" :sloped="isPsuedo"></news>

      <agenda :branch-id="branchId" id="agenda"></agenda>

      <!-- Partners -->
      <sponsors :branch-id="branchId"></sponsors>

      <!-- Questions -->
      <questions :branch-id="branchId" id="questions"></questions>

      <!-- Contact -->
      <contact :branch-options="branchOptions" id="contact"></contact>

      <!-- Footer -->
      <orca-footer :branch-id="branchId" :branch-options="branchOptions"></orca-footer>

      <enrollment-dialog ref="enrollmentDialog" :branch-options="branchOptions"></enrollment-dialog>
    </div>
  </div>
</template>

<script>

    import Contact from "../components/home/contact/Contact";
    import Questions from "../components/home/faq/Questions"
    import Branches from "../components/home/branches/Branches";
    import News from "../components/home/news/News";
    import Sponsors from "../components/home/sponsors/Sponsors";
    import Agenda from "../components/home/agenda/Agenda";
    import EnrollmentDialog from "../components/dashboard/enrollments/dialogs/EnrollmentDialog";
    import Photos from "../components/home/photos/Photos";
    import OrcaHeader from "../components/home/header/OrcaHeader";
    import OrcaFooter from "../components/home/footer/OrcaFooter";
    import ContentDisplayer from "../components/home/content/ContentDisplayer";
    import Branch from "../components/home/branches/Branch";

    export default {
        name: "Home",
        components: {
            Agenda,
            Sponsors,
            News,
            Branches,
            Branch,
            Contact,
            Questions,
            EnrollmentDialog,
            Photos,
            OrcaHeader,
            OrcaFooter,
            ContentDisplayer
        },
        data() {
            return {
                branchId: 1,
                branch: {},
                branchOptions: this.getBranchOptions(),
            }
        },
        mounted() {
            this.getBranch()
        },
        methods: {
            getBranchOptions() {
                this.$http.get('branches/list').then((response) => {
                    this.branchOptions = response.data;
                }).catch(function (error) {
                    this.branchOptions = [];
                    console.log(error)
                })
            },
            showEnrollmentDialog(branchId) {
                this.$refs.enrollmentDialog.add(branchId);
            },
            addEnrollment() {
                this.$refs.enrollmentDialog.newEnrollment();
            },
            changeBranch(branchId) {
                this.branchId = branchId;
                this.getBranch()
                scroll(0,0)
            },
            getBranch() {
                this.$http.get(`branches/${this.branchId}`).then((response) => {
                    this.branch = response.data
                }).catch(function (error) {
                    console.log(error)
                })
            },
        },
        computed: {
            isPsuedo() {
                if(this.branch) {
                    return this.branch.isPseudo;
                }
                return true;
            },
        }
    }
</script>

<style scoped>
  h1 {
    font-weight: normal;
  }

  .orc-banner-wrap {
    position: relative;
  }

  @media only screen and (max-width: 900px) {
    .blob {
      display: none;
    }
  }

  @media only screen and (max-width: 800px) {
    .orc-img-disp {
      display: none;
    }

    .orc-banner {
      padding-bottom: 10px !important;
      margin-bottom: 32px;
    }

    .orc-cont-wrap {
      padding-top: 60px;
    }
  }

  .orc-banner {
    padding-bottom: 290px;

  }

  .blob-container {
    display: flex;
    align-items: center;
    gap: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue